import { createFileRoute, Link } from "@tanstack/react-router";
import { StubAdminPage } from "@/components/admin/StubAdminPage";
import { Building2 } from "lucide-react";

export const Route = createFileRoute("/admin/suppliers")({
  component: () => (
    <StubAdminPage
      icon={Building2}
      title="Suppliers"
      subtitle="Partner supplier companies"
      action={
        <Link
          to="/admin"
          hash="companies"
          className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:opacity-90"
        >
          Add supplier
        </Link>
      }
    />
  ),
});
